//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data(){
        return {
            form: {
                oldCredential: '',
                newCredential: '',
                credential:''
            },
            size:'normal',
        }
    },
    mounted() {
        
    },
    methods: {

        /*保存密码*/
        saveData: function () {
            if(this.form.oldCredential==this.form.newCredential){
              this.$message.error('新密码不能与旧密码相同');
              return;
            }
            if(this.form.newCredential.length<6){
              this.$message.error('密码长度不能小于6位');
              return
            }
            if(this.form.newCredential!=this.form.credential){
              this.$message.error('新密码与确认密码不相同');
              return;
            }
            this.$put('/sys/user/modify/password',this.form,function(res){
                if(res.data==true){
                    this.$message.success('修改成功')
                    setTimeout(() => {
                        this.$router.back(-1);
                    }, 1000); 
                }else{
                    this.$message.error(res.msg)
                }
                
            },true)
           
        },

    }
}
